import type { EmailOtpRepository } from '@contexts/auth/domain';
import type { UseCase } from '@contexts/shared/application';
import { stringValueObject } from '@contexts/shared/domain';

export type GenerateEmailOtpSecretInput = {
	token: string;
};

export type GenerateEmailOtpSecretUseCase = UseCase<GenerateEmailOtpSecretInput, void>;

export function generateEmailOtpSecretBuilder(
	emailOtpRepository: EmailOtpRepository
): GenerateEmailOtpSecretUseCase {
	return async function generateEmailOtp(input: GenerateEmailOtpSecretInput): Promise<void> {
		const token = stringValueObject().validate('token', input.token);

		return emailOtpRepository.generateSecret(token);
	};
}
